import React from 'react';
import { defaultSelectOptions } from '../../customInspectionTypes/default/defaultSelectOptions';
import { useTranslate } from '../../mixins/translate/translate';

// eslint-disable-next-line @typescript-eslint/naming-convention
const ConditionScoreLabel = React.memo(
    (props: { value: number | undefined | null | string; options?: { value: string; name: string; translateText: string }[] }) => {
        const translate = useTranslate();
        if (props.value === null || props.value === undefined) {
            return null;
        }

        let scoreOptions = defaultSelectOptions.defaultScore;
        if (props.options) {
            scoreOptions = props.options;
        }

        const scoreItem = scoreOptions.filter((item) => item.value === props.value!.toString());
        if (scoreItem[0]) {
            const { name } = scoreItem[0];
            const labelText = translate(scoreItem[0].translateText);
            return (
                <span className={`label label-${name} p5 fs11`} style={{ color: '#FFFFFF' }}>
                    {labelText}
                </span>
            );
        }
        return null;
    },
);

ConditionScoreLabel.displayName = 'ConditionScoreLabel';
export { ConditionScoreLabel };
